/** REVIEW: 未レビュー */
import { defineStore } from 'pinia';

import {
  ShopDetailResponse,
  ShopRepository,
} from '@/repositories/generated';
import { toPostalCodeWithHyphen } from '@/utils';
import { ShopEditForm } from '@/validations/shop';

type TEditShopState = {
  form: ShopEditForm | undefined;
  initData: ShopDetailResponse | undefined;
};

export const useEditShopStore = defineStore('editShop', {
  state: (): TEditShopState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async editShop() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await ShopRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          companyId: initData.shopDetailBasicInfo.companyResponse.id,
          contractStoreId: form.contractStoreId || undefined, // contractStoreIdが空文字の場合にundefinedにしたいため||を使用
          defaultShop: form.defaultShop ?? false,
          externalId: form.externalId ?? '', // TODO: 店舗編集で外部店舗IDをnullableにする際に修正する
          homepageUrl: form.homepageUrl || undefined, // homepageUrlが空文字の場合にundefinedにしたいため||を使用
          lastUpdatedAt: initData.shopDetailBasicInfo.updatedAt,
          latitude: form.latitude ?? undefined,
          longitude: form.longitude ?? undefined,
          maxSettlementAmount: form.maxSettlementAmount ?? undefined,
          name: form.name ?? '',
          phone: form.phone ?? '',
          postalCode: toPostalCodeWithHyphen(form.postalCode) ?? '',
          shopEndDate: form.shopEndDate?.toISOString(),
          shopSettlementSetting: form.shopSettlementSetting.map((it) => ({
            creditFeeRatio: it.creditFeeRatio ?? 0,
            directBankFeeRatio: it.directBankFeeRatio ?? 0,
            prepaidChargeFeeRatio: it.prepaidChargeFeeRatio ?? 0,
            prepaidSettlementFeeRatio: it.prepaidSettlementFeeRatio ?? 0,
            pspGmoShopId: it.pspGmoShopId,
            pspGmoShopPassword: it.pspGmoShopPassword,
            shopSettlementServiceEndDate: it.shopSettlementServiceEndDate?.toISOString(),
            shopSettlementServiceStartDate: it.shopSettlementServiceStartDate.toISOString(),
            walletServiceSettlementSettingId: it.walletServiceSettlementSettingId,
          })),
          shopStartDate: form.shopStartDate.toISOString(),
          shopUpdateSmartCode: form.shopUpdateSmartCodeInfo ?? undefined,
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await ShopRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: ShopEditForm) {
      this.form = { ...form };
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
